/** 退款状态：与列表筛选 useFilterHeader 共用 */
export interface RefundStatusOption {
  label: string
  value: number | null
}

export const refundStatusList: RefundStatusOption[] = [
  { label: '全部', value: null },
  { label: '审核驳回', value: 12 },
  { label: '审批撤回', value: 11 },
  { label: '审批中', value: 10 },
  { label: '退款中', value: 30 },
  { label: '退款请求失败', value: 31 },
  { label: '退款失败', value: 32 },
  { label: '已退款', value: 40 },
  { label: '无法退款', value: 50 },
]

export function formatRefundStatus(val: unknown): string {
  if (val === null || val === undefined || val === '') return '--'
  const s = String(val)
  const found = refundStatusList.find((i) => i.value !== null && String(i.value) === s)
  return found?.label ?? s
}
